import React from "react";
const parseMarkdown = (md = "") => {
  let html = md;

  // code blocks
  html = html.replace(/```([\s\S]*?)```/g, "<pre><code>$1</code></pre>");

  // headings
  html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
  html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
  html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");

  // bold
  html = html.replace(/\*\*(.*?)\*\*/gim, "<strong>$1</strong>");

  // italic
  html = html.replace(/\*(.*?)\*/gim, "<em>$1</em>");

  // links
  html = html.replace(
    /\[(.*?)\]\((.*?)\)/gim,
    '<a href="$2" target="_blank">$1</a>',
  );

  // unordered lists
  html = html.replace(/^- (.*$)/gim, "<li>$1</li>");
  html = html.replace(/(<li>.*<\/li>)/gim, "<ul>$1</ul>");

  // line breaks
  html = html.replace(/\n/gim, "<br />");

  return html.trim();
};
type Props = {
  content?: string;
};

const MarkdownViewer = ({ content = "" }: Props) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: parseMarkdown(content),
      }}
    />
  );
};

export default MarkdownViewer;
